import { gql } from '@apollo/client'

export const GET_TRENDS_BASE_BY_CATEGORY_QUERY = gql`
  query getTrendsIdsByCategory {
    getTrendingHome {
      status
      relatedTerritory {
        territoryId
        name
      }
      data {
        id
        filtersObject
        totalPosts
        status: trendingType
        relevance
      }
    }
  }
`

export const GET_TREND_TERRITORIES_BY_IDS_QUERY = gql`
  query getTrendTerritoriesByIds($ids: [ID!]!) {
    listTerritories(ids: $ids) {
      territoryId
      name
      territoryPerformance {
        metrics {
          totalEngagement
        }
      }

      ... on Trending {
        createdAt
        query
      }
    }
  }
`
